// @flow strict

type MaybeString = null | void | false | 0 | string;

function classnames2(a: MaybeString, b: MaybeString) {
  return a ? (b ? `${a} ${b}` : a) : b || "";
}

function classnames3(a: MaybeString, b: MaybeString, c: MaybeString) {
  return a
    ? b
      ? c
        ? `${a} ${b} ${c}`
        : `${a} ${b}`
      : c
      ? `${a} ${c}`
      : a
    : classnames2(b, c);
}

function classnamesAny(...classes: Array<MaybeString>): string {
  return classes.filter(Boolean).join(" ");
}

// explicitly handling 2 arguments handles most of our use cases efficiently
function classnames(a: MaybeString, b: MaybeString, c: MaybeString): string {
  const numArgs = arguments.length;

  if (numArgs === 1) {
    return a || "";
  } else if (numArgs === 2) {
    return classnames2(a, b);
  } else if (numArgs === 3) {
    return classnames3(a, b, c);
  } else {
    return classnamesAny.apply(null, arguments);
  }
}

// We use the old commonJS module syntax because it's more efficient for
// utilities that are used in multiple files; it prevents concatenation,
// but it wouldn't be concatenated anyways
module.exports = (classnames: (...Array<MaybeString>) => string);
